export default __webpack_public_path__ + "static/media/pointualDetail.fcc582ae.png";